import Api from './api.service'

export default {
  getMakeModels (type) {
    return Api().get(`/backend/vehicles/makemodels/${type}`)
  }
}
